/*****************************************************************************************************************************************************
 * Frequency message monitoring *
 ****************************************************************************************************************************************************/
define('commons/monitoring/frequency-message-monitoring',['jquery', 'commons/monitoring/base-monitoring'], function($, BaseMonitoring) {
    var FrequencyMessageMonitoring = function() {
        // Call parent init method
        BaseMonitoring.apply(this, arguments);
    };

    // Inherit from MessageMonitoring
    for ( var element in BaseMonitoring.prototype) {
        FrequencyMessageMonitoring.prototype[element] = BaseMonitoring.prototype[element];
    }

    FrequencyMessageMonitoring.prototype.processResponse = function(response) {
        var threshold = 1000000;
        response.reverse();
        // Detect stations
        var stations = {};
        var labels = ["Time"];
        for (var i = 0; i < response.length; i++) {
            var info = response[i];
            for (var j = 0; j < info.rinfo.length; j++) {
                var rinfo = info.rinfo[j];
                if (stations[rinfo.tap] === undefined && rinfo.freq > threshold) {
                    stations[rinfo.tap] = labels.length;
                    labels.push("Base station[" + rinfo.tap + "]");
                }
            }
        }

        // Prepare data to plot
        var data = [];
        for (var i = 0; i < response.length; i++) {
            var info = response[i];
            var date = new Date();
            date.setTime(info.time);
            var row = new Array(labels.length);
            row[0] = date;
            var found = false;
            for (var j = 0; j < info.rinfo.length; j++) {
                var rinfo = info.rinfo[j];
                if (rinfo.freq > threshold) {
                    row[stations[rinfo.tap]] = rinfo.freq;
                    found = true;
                }
            }
            if (found) {
                data.push(row);
            }
        }

        var drawOptions = $.extend({
            labelsKMB: true,
            axes: {
                y: {
                    valueFormatter: function(x) {
                        var units = ["Hz", "kHz", "MHz"];
                        var result = String(x);
                        var mod = Math.floor((result.length - 1) / 3);
                        mod = Math.min(mod, units.length - 1);
                        var pos = mod * 3;
                        if (pos > 0) {
                            result = result.substr(0, result.length - pos) + "." + result.substr(result.length - pos, pos);
                        }
                        result += units[mod];
                        return result;
                    }
                }
            }
        }, this.drawOptions);

        return {
            data: data,
            labels: labels,
            drawOptions: drawOptions
        };
    };
    
    return FrequencyMessageMonitoring;
});
